
export function invertResult(promise: Promise<boolean>): Promise<boolean> {
    const origPromise = promise;

    return new Promise<boolean>(function(resolve, reject) {
        origPromise
            .then(val => resolve(!val))
            .catch(error => reject(error));
    });
}
